<button #button mat-icon-button type="button" [attr.aria-label]="_intl.openTimepickerLabel"
        [attr.aria-haspopup]="timepicker ? 'dialog' : null" [attr.tabindex]="disabled ? -1 : tabIndex"
        [disabled]="disabled"
        [disableRipple]="disableRipple" (click)="_open($event)">

  <svg *ngIf="!_customIcon" class="mate-timepicker-toggle-default-icon" viewBox="0 0 24 24"
       width="24px" height="24px" fill="currentColor" focusable="false">
    <path d="M15.87 15.25l-3.37-2V8.72c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1zm5.31-10.24L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
  </svg>

  <ng-content select="[mateTimepickerToggleIcon]"></ng-content>
</button>
